/**
 * Browser detection utilities for Safari-specific fallbacks.
 * Use sparingly - prefer feature detection when possible.
 */

export const isSafari = (): boolean =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.vendor?.includes('Apple') ?? false);

export const isLighthouseOrBot = (): boolean => {
  if (typeof window === 'undefined') return true;
  const ua = navigator.userAgent || '';
  return (
    /Lighthouse|Googlebot|bingbot|Storebot|crawler|bot/i.test(ua) ||
    /HeadlessChromium/i.test(ua) ||
    (navigator.webdriver ?? false)
  );
};
